import React, { useState, useEffect } from "react";
import "./styles/Loader.css";

const Loader = () => {
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const [bgColor, setBgColor] = useState("#333");

  
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev < 100) {
          return prev + 20;
        }
        clearInterval(interval);
        setLoading(false);
        return 100;
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);


 
  return (
    <>
      {loading && (
        <div className="loader-container">
           <div className="logo-container">
            <img src="/images/logoKvadratBezPozadine.webp" alt="Logo" className="loader-logo" />
          </div>
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{
                width: `${progress}%`,
                backgroundColor: progress === 100 ? "#4CAF50" : "#bb823c",
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Loader;